import { useNavigate } from "react-router-dom";
import type { RouteStopDetail } from "../../../mocks/routeDetails";
import { getStopIcon } from "../../../mocks/routeDetails";

interface RouteStopTimelineProps {
  stops: RouteStopDetail[];
}

const TYPE_COLORS: Record<string, string> = {
  "Tarihi":    "bg-amber-100 text-amber-700",
  "Kültür":    "bg-purple-100 text-purple-700",
  "Yemek":     "bg-red-100 text-red-700",
  "Öğle":      "bg-red-100 text-red-700",
  "Akşam":     "bg-red-100 text-red-700",
  "Kahvaltı":  "bg-orange-100 text-orange-700",
  "Doğa":      "bg-emerald-100 text-emerald-700",
  "Eğlence":   "bg-sky-100 text-sky-700",
  "Macera":    "bg-indigo-100 text-indigo-700",
  "Konaklama": "bg-stone-100 text-stone-700",
  "Atıştırma": "bg-pink-100 text-pink-700",
  "Tatlı":     "bg-pink-100 text-pink-700",
  "Alışveriş": "bg-violet-100 text-violet-700",
  "Kahve":     "bg-amber-100 text-amber-800",
  "Park":      "bg-green-100 text-green-700",
};

export default function RouteStopTimeline({ stops }: RouteStopTimelineProps) {
  const navigate = useNavigate();

  return (
    <div className="space-y-0">
      {stops.map((stop, idx) => {
        const isLast = idx === stops.length - 1;
        const colorClass = TYPE_COLORS[stop.type] ?? "bg-stone-100 text-stone-600";
        const icon = getStopIcon(stop.type);

        return (
          <div key={stop.order} className="flex gap-4">
            {/* Timeline indicator */}
            <div className="flex flex-col items-center flex-shrink-0">
              <div className={`w-9 h-9 rounded-full flex items-center justify-center z-10 flex-shrink-0 ${colorClass}`}>
                <i className={`${icon} text-sm`} />
              </div>
              {!isLast && <div className="w-0.5 bg-stone-200 flex-1 my-1 min-h-[1.5rem]" />}
            </div>

            {/* Stop content */}
            <div className={`pb-5 flex-1 min-w-0 ${isLast ? "" : ""}`}>
              <div className="flex flex-wrap items-center gap-2 mb-1">
                <span className="text-xs font-bold text-stone-400 tracking-widest">{String(stop.order).padStart(2, "0")}</span>
                <h4 className="font-semibold text-stone-800 text-sm">
                  {stop.venueId ? (
                    <button
                      onClick={() => navigate(`/venue/${stop.venueId}`)}
                      className="hover:text-emerald-700 transition-colors cursor-pointer text-left"
                    >
                      {stop.name}
                    </button>
                  ) : (
                    stop.name
                  )}
                </h4>
                <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${colorClass}`}>
                  {stop.type}
                </span>
              </div>

              <p className="text-stone-500 text-xs leading-relaxed mb-2">{stop.description}</p>

              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-1 text-xs text-stone-400">
                  <i className="ri-time-line" />
                  <span>{stop.duration}</span>
                </div>
                {stop.tip && (
                  <div className="flex items-center gap-1 text-xs text-amber-600">
                    <i className="ri-lightbulb-line" />
                    <span className="italic">{stop.tip}</span>
                  </div>
                )}
                {stop.venueId && (
                  <button
                    onClick={() => navigate(`/venue/${stop.venueId}`)}
                    className="text-xs text-emerald-700 hover:text-emerald-800 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
                  >
                    Detay <i className="ri-arrow-right-s-line" />
                  </button>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
